import React from 'react'
import mr_connect_content_1 from '../../../assets/images/content/mr-connect-data-platform/mrconnect-data-platform-1.png'
import mr_connect_content_2 from "../../../assets/images/content/mr-connect-data-platform/mrconnect-data-platform-2.png"
import mr_connect_content_3 from "../../../assets/images/content/mr-connect-data-platform/mrconnect-data-platform-3.png"
import { PrimaryButton } from '../../../components/StyledButton'
import soracom from "../../../assets/images/content/mr-connect-data-platform/soracom.png"
import konvoy from "../../../assets/images/content/mr-connect-data-platform/konvoy.png"
import ems from "../../../assets/images/content/mr-connect-data-platform/ems.png"
import nxtiot from "../../../assets/images/content/mr-connect-data-platform/nxtiot.png"
import Slider from "react-slick";
import KeyBenefitTab from './KeyBenefitTab'
import { useTranslation } from 'react-i18next'

const MrConnectIotCloudPlatform = () => {
  const {t} = useTranslation()

  document.title = t("documentTitle.mrconnect-iot-cloud-platform")

  var settings = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const sliderData = [
    {
      content: t('mrconnect-iot-cloud-platform.slider.slider-1'),
      author: t('mrconnect-iot-cloud-platform.slider.author-1')
    },
    {
      content: t('mrconnect-iot-cloud-platform.slider.slider-2'),
      author: t('mrconnect-iot-cloud-platform.slider.author-2')
    }
  ]

  const trustedByData = [
    {
      img: soracom,
      title: t('mrconnect-iot-cloud-platform.cellular-iot-connectivity-provider'),
      subTitle: t('mrconnect-iot-cloud-platform.japan')
    },
    {
      img: konvoy,
      title: t('mrconnect-iot-cloud-platform.beer-kegs-rental'),
      subTitle: t('mrconnect-iot-cloud-platform.australia')
    },
    {
      img: ems,
      title: t('mrconnect-iot-cloud-platform.smart-meter-manufacturer'),
      subTitle: t('mrconnect-iot-cloud-platform.taiwan')
    },
    {
      img: nxtiot,
      title: t('mrconnect-iot-cloud-platform.iot-system-integrator'),
      subTitle: t('mrconnect-iot-cloud-platform.mexico')
    },
  ]

  return (
    <div className='w-full mrconnect-iot-cloud-platform'>
      <div className='w-full bg-mrconnect-iot-cloud-platform py-0 lg:py-10'>
        <div className='container grid grid-cols-12 gap-y-10'>
          <div className='col-span-12 lg:col-span-7 flex flex-col gap-4 lg:gap-8 pt-10 sm:pt-7 lg:pt-42'>
            <img src={mr_connect_content_1} alt="mr_connect_logo" className='img-reponsive' />
            <p className='font-semibold text-3xl md:text-40px text-primary pr-10 sm:pt-0'>{t('mrconnect-iot-cloud-platform.fast-secure-scalable')}</p>
            <p className='text-xl lg:text-2xl'>{t('mrconnect-iot-cloud-platform.a-middleware-cloud-platform-for-iot-device-management')}</p>
          </div>
          <div className='col-span-12 lg:col-span-5 lg:pt-28 2xl:pt-19 flex justify-center lg:pb-0'>
            <img src={mr_connect_content_2} alt="mr_connect_content_1" className='img-reponsive w-[500px] lg:w-auto' />
          </div>
        </div>
      </div>
      <div className='container pt-15'>
        <p className='text-3xl md:text-40px font-semibold text-primary'>{t('mrconnect-iot-cloud-platform.a-simpleway-to-manage-large-fleet')}</p>
        <p className='pt-3'>{t('mrconnect-iot-cloud-platform.mrconnect-allow-you-to-remotely-onboard')}</p>
        <p className='pt-3'>{t('mrconnect-iot-cloud-platform.by-alleviating-the-technocal-burden')}</p>
        <div className='flex flex-wrap lg:flex-nowrap pt-10 gap-10 justify-between'>
          <div className='shadow-card p-12 rounded-md flex flex-col justify-center items-center w-full gap-3'>
            <p className='font-extrabold text-blue-primary text-5xl'>{t('mrconnect-iot-cloud-platform.1-million-plus')}</p>
            <p className=''>{t('mrconnect-iot-cloud-platform.devices-communicating-daily')}</p>
          </div>
          <div className='shadow-card p-12 rounded-md flex flex-col justify-center items-center w-full gap-3'>
            <p className='font-extrabold text-blue-primary text-5xl'>{t('mrconnect-iot-cloud-platform.up-to-10x')}</p>
            <p className=''>{t('mrconnect-iot-cloud-platform.cheaper-than-existing-solutions')}</p>
          </div>
        </div>
        <div className='pt-10 flex justify-center'>
          <PrimaryButton>{t('button.technical-documentation')}</PrimaryButton>
        </div>
      </div>
      <div className='py-15 container'>
        <p className='text-40px font-semibold text-primary'>{t('mrconnect-iot-cloud-platform.how-mrconnect-work')}</p>
        <p className='pt-3'>{t('mrconnect-iot-cloud-platform.all-message-are-received-decoded-and-stored')}</p>
        <div className='pt-10'>
          <img src={mr_connect_content_3} alt="mr_connect_data_platform_2" className='img-responsive' />
        </div>
      </div>
      
        <KeyBenefitTab/>
    
      <div className='w-full bg-[#F5F7FA] mt-10'>
        <div className='container py-15'>
          <p className='text-center text-3xl md:text-40px font-semibold text-primary'>{t('mrconnect-iot-cloud-platform.mrconnect-is-trusted-by')}</p>
          <div className='grid grid-cols-4 pt-5 gap-y-5'>
            {trustedByData.map((value, index) => (
              <div className='col-span-4 md:col-span-2 xl:col-span-1' key={index}>
                <div className='flex flex-col items-center justify-between gap-2' >
                  <div className='h-20 flex justify-center items-center'>
                    <img src={value.img} alt={value.title} width="160" className='' />
                  </div>
                  <p className=''>{value.title}</p>
                  <p className=''>{value.subTitle}</p>
                </div>
              </div>
            ))}
          </div>
          <div className='flex justify-center pt-10'>
            <PrimaryButton>{t('button.contact-us')}</PrimaryButton>
          </div>
        </div>
      </div>

      <div className='w-full bg-mrconnect-iot-cloud-platform-footer relative'>
        <div className="container relative z-10">
          <div className='pt-20 md:pt-24'>
            <Slider {...settings}>
              {sliderData.map((value, index) => (
                <div key={index}>
                  <div className='flex flex-col gap-5'>
                    <p className='text-lg lg:text-2xl text-white font-semibold text-center'>{value.content}</p>
                    <p className='text-[#EEF3FA] text-sm lg:text-base text-center md:text-right'>{value.author}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div >
  )
}

export default MrConnectIotCloudPlatform